export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9778.0c73e059.jpg";